<mat-sidenav-container class="app-container">
  <mat-sidenav #drawer mode="side" opened class="app-sidenav">
    <div class="logo-container">
      <h2 class="app-name">
        <img src="/assets/images/Letter.jpg" alt="Logo">
      </h2>
    </div>

    <mat-nav-list>
         
      <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
        <mat-icon>dashboard</mat-icon>
        Dashboard
      </a> 
    
      <a mat-list-item class="nested" (click)="isEmployeeExpanded = !isEmployeeExpanded">
        <mat-icon>insert_chart_outlined</mat-icon>
        Reports
        <mat-icon class="expand-icon">
          {{ isEmployeeExpanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </a>

      <div *ngIf="isEmployeeExpanded" class="submenu">
        <a mat-list-item class="nested-child" routerLink="/salesreport" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Sales Report
        </a>
        <a mat-list-item class="nested-child" routerLink="/purchasereport" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Purchase Report
        </a>
        <a mat-list-item class="nested-child" routerLink="/stockreport" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Stock Report
        </a>
      </div>
<a mat-list-item class="nested" (click)="isMasterExpanded = !isMasterExpanded">
          <mat-icon> currency_exchange</mat-icon>
        Exchange
        <mat-icon class="expand-icon">
          {{ isEmployeeExpanded ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </a>

      <div *ngIf="isMasterExpanded" class="submenu">
        <a mat-list-item class="nested-child" routerLink="/salesapproval" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Sales Approval
        </a>
        <a mat-list-item class="nested-child" routerLink="/stockexchange" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Stock Approval
        </a>
         <a mat-list-item class="nested-child" routerLink="/stockchecking" routerLinkActive="active">
          <mat-icon>arrow_right</mat-icon>
          Stock Check Approval
        </a>
       
      </div>


    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary" class="custom-toolbar">
      <button mat-icon-button (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <span class="app-title">Mr.Mobile Report</span>
      <span class="spacer"></span>
      <div class="user-section">
        <button mat-icon-button>
          <mat-icon>account_circle</mat-icon>
        </button>
        <button mat-button color="accent" (click)="logout()" class="logout-btn">Logout</button>
      </div>
    </mat-toolbar>

    <div class="content">
      <router-outlet></router-outlet>
    </div>

    <mat-toolbar class="footer" color="primary">
      <span>&copy; 2025 Mr.Mobile. All rights reserved.</span>
    </mat-toolbar>
  </mat-sidenav-content>
</mat-sidenav-container>
